import React, { Suspense, lazy } from 'react';

import { SidebarProvider } from './context/SidebarContext';
import ThemedSuspense from './components/ThemedSuspense';
import { Windmill } from '@windmill/react-ui';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import Home from './pages/Home';

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const CreateAccount = lazy(() => import('./pages/CreateAccount'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const ResetPassword = lazy(() => import('./pages/ResetPassword'))

const RequireAuth = ({ children }) => {
  if (!sessionStorage.getItem('sessionToken')) {
    return <Redirect to="/login" />;
  }

  return children;
}

const AppRoutes = () => {
  if (process.env.NODE_ENV === 'development') {
    return (
      <>
        <Route path="/login" component={Login} />
        <Route path="/create-account" component={CreateAccount} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />

        {/* Place new routes over this */}
        <RequireAuth>
          <Route path="/app" component={Layout} />
        </RequireAuth>
      </>
    )
  }

  return <></>
}

function App() {
  return (
    <SidebarProvider>
      <Suspense fallback={<ThemedSuspense />}>
        <Windmill usePreferences>
          <Router>
            <AccessibleNavigationAnnouncer />
            <Switch>
              <Route exact path="/" component={Home} />
              {AppRoutes()}
            </Switch>
          </Router>
        </Windmill>
      </Suspense>
    </SidebarProvider>
  );
}

export default App